const initialState = {
    current: null,
    authenticated: false,
    isFulfilled: false,
};

export { initialState as default };
//# sourceMappingURL=initialState.js.map
